import React from 'react';
import Svg from 'rp-react-svg-icon';

const LoadingRow = () => (
    <div className="nr-loading">
        <Svg
            iconName="spinner"
            size="2XL"
            className="nr-loading__icon"
        />
    </div>
);

export default LoadingRow;



// WEBPACK FOOTER //
// ./src/js/nonRunners/components/LoadingRow.jsx